import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LocaleLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/tours/TourCard.tsx");
